<template>
  <div style="align-items: baseline">
  <div style="display: flex; align-items: center; ">
    <img :src="require('@/assets/nepaliport_logo.png')" alt="Avatar"
         style="width: 370px;">
  </div>
  <div class="mt-2 justify-center" style="display: flex; margin-bottom: 13px;">
    <div class="app-name-panel">{{textItem}}</div>
  </div>
  </div>
</template>

<script>
export default {
  props: ["textItem"]
};
</script>